// 高德地图 key
export const MapKey = 'cfadbf87eae244e4157bdd8243c3cae3'
// 高德地图样式
export const mapStyle = 'amap://styles/2fcce7500c3e26e7574b4b7157a487ea'
// 版本号
export const version = '1.4.15'
// 高德地图 ui  Url
export const mapMainUrl = 'https://webapi.amap.com/maps?v=' + version + '&key=' + MapKey
export const uiMainUrl = 'https://webapi.amap.com/ui/1.0/main.js?v=1.0.11'
// 高德地图 基本配置
export const mapConfigs = {
    zoom: 5,
    mapStyle: mapStyle,
    resizeEnable: false,
    doubleClickZoom: false,
    zooms:[4,18]
}
// 加载PositionPicker，loadUI的路径参数为模块名中 'ui/' 之后的部分
export const loadUIArr = [
    'ui/misc/PathSimplifier',
    'ui/misc/PositionPicker',
    'ui/geo/DistrictExplorer',
    'ui/control/BasicControl',
    'lib/$'
]

